import React, { useState } from "react";
import Image from "next/image";
import CancellationTermsModal from "./CancellationTermsModal";

const InfoTitle = ({ sozlesme }) => {
  const [termModal, setTermModal] = useState(false);
  return (
    <div className="flex flex-col items-start ">
      <span className="text-themeBlack text-xl font-medium leading-normal lg:mb-5 mb-3 block">
        Bilmeniz <br /> Gerekenler
      </span>
      <div className="inline-flex items-center gap-2.5 py-2 pl-2 pr-7 rounded-[50px] border border-[#D15050] border-opacity-15 bg-[#D15050] bg-opacity-10">
        <Image
          src="/icons/infoIcons.svg"
          width={14}
          height={14}
          alt="Info Icon"
          className="object-contain"
        />
        <button
          type="button"
          onClick={() => setTermModal(true)}
          className="text-[#EC6701] text-sm font-medium leading-normal underline"
        >
          İptal ve İade şartları
        </button>
      </div>
      <CancellationTermsModal
        sozlesme={sozlesme}
        termModal={termModal}
        setTermModal={setTermModal}
      />
    </div>
  );
};

export default InfoTitle;
